import { focusOutline } from 'shared/assets/styles';
import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const datePickerWrapperClassName = 'date-picker-wrapper-class';

export const Container = styled.div`
  display: inline-block;
  width: 100%;

  .${datePickerWrapperClassName} {
    width: 100%;
  }

  & input {
    box-shadow: ${({ theme }) => theme.shadowBox.select};
  }

  & input:focus {
    ${focusOutline};
  }
`;

export const Error = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.caption)};
  display: block;
  margin-top: ${({ theme }) => theme.spacing(1)};

  color: ${({ theme }) => theme.palette.error.main};
`;
